import React, {useEffect, useRef, useState} from 'react';
import Icon from '../../Icon/Icon';
import './MobileCatalog.css';

function MobileCatalog(props) {
  const {
    findParentSection,
    section,
    setActiveCatalogSection,
    items,
  } = {...props};

  const [rootSections, setRootSections] = useState([]);
  const [sections, setSections] = useState([]);
  const rightListRef = useRef(null);

  useEffect(() => {
    setRootSections(items.filter(item => {
      return item.hasOwnProperty('depthLevel') && Number(item.depthLevel) ===
        1;
    }).sort((a, b) => {
      if (isNaN(a.sortValue) || isNaN(b.sortValue) || Number(a.sortValue) ===
        Number(b.sortValue)) return 0;
      return Number(a.sortValue) > Number(b.sortValue) ? 1 : -1;
    }));
  }, [items]);

  const activeRootSectionId = getRootSectionId(section);

  // make sections array
  useEffect(() => {
    const parentSectionId = activeRootSectionId;

    if (parentSectionId > 0) {
      setSections(items.filter(item => {
        return item.hasOwnProperty('parentId') && Number(item.parentId) > 0 &&
          Number(item.parentId) === parentSectionId;
      }).sort((a, b) => {
        if (isNaN(a.sortValue) || isNaN(b.sortValue) || Number(a.sortValue) ===
          Number(b.sortValue)) return 0;
        return Number(a.sortValue) > Number(b.sortValue) ? 1 : -1;
      }));
    } else {
      setSections([]);
    }
  }, [activeRootSectionId, items]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (rightListRef.current) {
        rightListRef.current.scrollTop = 0;
      }
    });
  }, [activeRootSectionId]);


  function hasChildren(id) {
    let hasChildren = false;

    items.forEach(item => {
      if (item.hasOwnProperty('parentId') && Number(item.parentId) > 0 &&
        Number(item.parentId) === Number(id))
        hasChildren = true;
    });

    return hasChildren;
  }

  function getChildren(id) {
    return items.filter(item => {
      return item.hasOwnProperty('parentId') && Number(item.parentId) > 0 &&
        Number(item.parentId) === Number(id);
    }).sort((a, b) => {
      if (isNaN(a.sortValue) || isNaN(b.sortValue) || Number(a.sortValue) ===
        Number(b.sortValue)) return 0;
      return Number(a.sortValue) > Number(b.sortValue) ? 1 : -1;
    });
  }

  function onClick(event, item) {
    if (item.hasOwnProperty('depthLevel') && Number(item.depthLevel) === 3 &&
      item.hasOwnProperty('link'))
      window.location.href = item.link;
    else if (item.hasOwnProperty('itemId')) {
      // check children
      if (!hasChildren(item.itemId)) {
        window.location.href = item.link;
      } else {
        // proxy active catalog section to parent
        setActiveCatalogSection(item);
      }
    }
  }

  function getRootSectionId(section) {
    if (!section) {
      const defaultRootSection = rootSections.find(item => hasChildren(item.itemId)) ||
        rootSections[0] ||
        null;

      return defaultRootSection ? Number(defaultRootSection.itemId) : 0;
    }

    if (Number(section.depthLevel) === 1) {
      return Number(section.itemId);
    }

    let parentSection = findParentSection(section.parentId);

    while (parentSection && Number(parentSection.depthLevel) > 1) {
      parentSection = items.find(item => {
        return item.hasOwnProperty('itemId') && Number(item.itemId) ===
          Number(parentSection.parentId);
      });
    }

    return parentSection ? Number(parentSection.itemId) : 0;
  }

  const sectionGroups = sections;

  function renderSectionGroup(item) {
    const children = getChildren(item.itemId);
    const image = item.sectionImage;
    const isLikeNew = item.symbol === 'kak-novyy';

    return (
      <li
        key={`section-${item.itemId}`}
        className={'flex flex-col gap-[14px] border border-solid border-[#EAEAEA] rounded-[12px] p-[10px] w-full'}>
        <div
          className={`flex items-center justify-between gap-2 w-full ${hasChildren(item.itemId) ? 'border-b border-l-0 border-r-0 border-t-0 border-solid border-[#EAEAEA] pb-[12px]' : ''}`}>
          <a href={item.link}
             className={'flex items-center gap-2 w-full'}>
            {
              image && image.length && (
                <img src={image}
                     className="min-w-[40px]"
                     width="40px"
                     height="40px"/>
              )
            }
            {
              isLikeNew ? (
                <span className="mobile-catalog-like-new">
                  <span className="mobile-catalog-like-new__title text-[16px] leading-normal font-medium text-[#1A1A1A] 400:line-clamp-2">
                    {item.title}
                  </span>
                  <span className="mobile-catalog-like-new__icon" aria-hidden="true"/>
                </span>
              ) : (
                <span className="text-[16px] leading-normal font-medium text-[#1A1A1A] 400:line-clamp-2">
                  {item.title}
                </span>
              )
            }
            {
              Number(item.newSection) > 0 && (
                <span
                  className="self-start text-[10px] leading-[15px] font-medium italic text-red-mistake">new</span>
              )
            }
            {
              item.depthLevel < 3 && (
                <span
                  className={`justify-items-end ml-auto grow flex justify-end ${!hasChildren(item.itemId) ? 'opacity-0' : ''}`}>
                <Icon name={`menu-right-arrow-icon`}
                      className={'w-[8px] h-[13px]'}/>
              </span>
              )
            }
          </a>
        </div>
        {
          children.length > 0 && (
            <ul className={'flex flex-col gap-[14px]'}>
              {
                children.map(child => {
                  return (
                    <li
                      key={`child-section-${child.itemId}`}
                      className={'flex items-center h-auto gap-2 w-full'}
                      onClick={event => onClick(event, child)}>
                      <span className="text-[14px] leading-normal text-[#1A1A1A]">
                        {child.title}
                      </span>
                      {
                        Number(child.newSection) > 0 && (
                          <span
                            className="self-start text-[10px] leading-[15px] font-medium italic text-red-mistake">new</span>
                        )
                      }
                    </li>
                  )
                })
              }
            </ul>
          )
        }
      </li>
    );
  }

  return (
    <div className={`h-full mx-5 pt-4 ${section === null ? 'pb-3' : 'pb-1' }`}>

      <div className={`h-full flex gap-2.5`}>
        <ul className={`flex flex-col gap-2 shrink-0 w-[120px] h-full overflow-auto [scrollbar-width:none] [-ms-overflow-style:none]`}>
          {
            rootSections.map((item) => {
              const active = Number(activeRootSectionId) === Number(item.itemId);

              return (
                <React.Fragment key={`root-section-${item.itemId}`}>
                  <li
                    className={`flex flex-col h-auto border border-solid rounded-[12px] p-[10px] gap-2 w-full ${active ? 'bg-[#F9F4FF] border-[#6364FF]' : 'border-[#EAEAEA]'}`}
                    onClick={event => active ? window.location.href = item.link : onClick(event, item)}>
                    {
                      Number(item.depthLevel) === 1 &&
                      item.hasOwnProperty('image') && item.image &&
                      item.image.length &&
                      item.hasOwnProperty('imageAdditional') &&
                      item.imageAdditional &&
                      item.imageAdditional.length && (
                        <img src={item.imageAdditional}
                             className="min-w-[40px]"
                             width="40px"
                             height="40px"/>
                      )
                    }
                    <span className="text-[14px] font-medium leading-normal text-[#1A1A1A] break-words 400:line-clamp-2">
                   {item.title}
                 </span>
                    {
                      Number(item.newSection) > 0 && (
                        <span
                          className="self-start text-[10px] leading-[15px] font-medium italic text-red-mistake">new</span>
                      )
                    }
                  </li>
                </React.Fragment>
              )
            })
          }
        </ul>
        <div ref={rightListRef}
             className='flex flex-col gap-[20px] h-full w-full overflow-auto [scrollbar-width:none] [-ms-overflow-style:none]'>
          <ul className={`flex flex-col gap-2.5 grow`}>
            {
              sectionGroups.map(item => renderSectionGroup(item))
            }
          </ul>
        </div>

      </div>
    </div>
  );
}

export default MobileCatalog;